import { connect } from 'react-redux';
import { compose } from 'ramda';
import OSSAgreementContent from './oss-agreement-content';
import LoginActions from 'Redux/LoginRedux';
import { translate } from 'react-translate';
import { getOSSAgreementInfoSelector } from '../../oss-agreement.reducer';
import { withRouter } from 'react-router-dom';

const mapStateToProps = (state) => ({
  ...getOSSAgreementInfoSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  logOut: () => dispatch(LoginActions.loginLogoutRequest()),
});

export default compose(
  translate('HelpMenu'),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(OSSAgreementContent);
